import { useQuery } from '@tanstack/react-query';
import type { OptimisationRunDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface OptimisationRunApiResponse {
  success: boolean;
  data: OptimisationRunDto;
}

const POLLING_STATUSES = new Set(['QUEUED', 'RUNNING']);

export function useOptimisationRun(id: number | undefined) {
  return useQuery({
    queryKey: queryKeys.optimisation.byId(id ?? 0),
    queryFn: async () => {
      const response = await apiClient.get<OptimisationRunApiResponse>(
        `/optimisation/runs/${id}`,
      );
      return response.data.data;
    },
    enabled: id != null && id > 0,
    refetchInterval: (query) => {
      const status = query.state.data?.runStatus;
      return status && POLLING_STATUSES.has(status) ? 2000 : false;
    },
  });
}
